import { mount } from '@universal-input/loader';
import type { WidgetSessionBootstrap } from '@universal-input/contracts';

const profileKey = document.body.dataset.profile;
const context = document.body.dataset.context;
const status = document.querySelector<HTMLElement>('#status');
if (!profileKey || !context || !status) throw new Error('Demo configuration is missing');

try {
  const storageKey = `universal-input-demo-session:${profileKey}:${context}`;
  const session = await bootstrapSession(storageKey);
  status.textContent = `Session ${session.sessionId.slice(0, 8)} ist bereit.`;
  mount({
    container: '#widget',
    widgetOrigin: window.location.origin,
    profileKey,
    sessionId: session.sessionId,
    launchToken: session.launchToken,
    onEvent(event) {
      if (event.type === 'progress') status.textContent = `Upload: ${Math.round(event.bytesUploaded / Math.max(event.bytesTotal, 1) * 100)} %`;
      if (event.type === 'session-complete') {
        localStorage.removeItem(storageKey);
        status.textContent = 'Upload abgeschlossen; die Dateien wurden geprüft.';
      }
      if (event.type === 'error') status.textContent = `Fehler: ${event.message}`;
    },
  });
} catch (error) {
  status.textContent = error instanceof Error ? error.message : 'Demo konnte nicht gestartet werden.';
}

async function bootstrapSession(storageKey: string): Promise<WidgetSessionBootstrap> {
  const existingSessionId = localStorage.getItem(storageKey);
  if (existingSessionId) {
    const resume = await fetch(`/demo/widget-sessions/${encodeURIComponent(existingSessionId)}/resume-token`, {
      method: 'POST',
    });
    if (resume.ok) return resume.json() as Promise<WidgetSessionBootstrap>;
    localStorage.removeItem(storageKey);
  }
  const response = await fetch('/demo/widget-sessions', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      profileKey,
      contextId: context,
      metadata: profileKey === 'document-intake' ? { caseId: context } : { visitId: context },
    }),
  });
  if (!response.ok) throw new Error(`Session konnte nicht erstellt werden (HTTP ${response.status})`);
  const session = await response.json() as WidgetSessionBootstrap;
  localStorage.setItem(storageKey, session.sessionId);
  return session;
}
